import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import StarIcon from '@material-ui/icons/Star';

const Star = (props) => {
  return (
    <>
      { props.selected &&
        <StarIcon style={{ cursor: 'pointer' }} onClick={(e) => props.handleClick()} />
      }
      { !props.selected &&
        <StarBorderIcon style={{ cursor: 'pointer' }} onClick={(e) => props.handleClick()} />
      }

    </>
  );
}
export default (props) => {
  const [stars, setStars] = React.useState(0);
  const [star1, setStar1] = React.useState(false);
  const [star2, setStar2] = React.useState(false);
  const [star3, setStar3] = React.useState(false);
  const [star4, setStar4] = React.useState(false);
  const [star5, setStar5] = React.useState(false);

  const surveyUrl = `${props.config.url}?stars=${stars}&email=${props.email}`;

  const handleClose = () => {
    props.handleClose();
  };

  const handleSurvey = () => {
    props.handleClose();
    setTimeout(() => {
      window.open(surveyUrl, "_blank");
    }, 200);
  };

  const handleStar = (num) => {
    // console.log('handleStar', num);
    setStars(num);

    setStar1(false);
    setStar2(false);
    setStar3(false);
    setStar4(false);
    setStar5(false);
    switch (num) {
      case 1:
        setStar1(true);
        break;
      case 2:
        setStar1(true);
        setStar2(true);
        break;
      case 3:
        setStar1(true);
        setStar2(true);
        setStar3(true);
        break;
      case 4:
        setStar1(true);
        setStar2(true);
        setStar3(true);
        setStar4(true);
        break;
      case 5:
        setStar1(true);
        setStar2(true);
        setStar3(true);
        setStar4(true);
        setStar5(true);
        break;
      default: break;
    }
    setTimeout(() => {
      window.open(props.config.url, "_blank");
    }, 500);
    props.handleClose();
  };

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        aria-labelledby="survey-dialog-title"
        aria-describedby="survey-dialog-description"
      >
        <DialogTitle id="survey-dialog-title">
          {props.config.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="survey-dialog-description">
            {props.config.description}
          </DialogContentText>
          <div>
            <Star selected={star1} handleClick={() => handleStar(1)} />
            <Star selected={star2} handleClick={() => handleStar(2)} />
            <Star selected={star3} handleClick={() => handleStar(3)} />
            <Star selected={star4} handleClick={() => handleStar(4)} />
            <Star selected={star5} handleClick={() => handleStar(5)} />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">Close</Button>
          <Button variant="contained" onClick={handleSurvey} color="primary">Submit</Button>
        </DialogActions>
      </Dialog>
    </div >
  );
};